export default __webpack_public_path__ + "static/live_more_logo-9aceef38b811966300fb1cd0b21ff0ed.png";